import { useContext, useEffect } from 'react';
import { useAppQuery } from 'services/reactQuery/useAppQuery';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { formFields } from 'consts/form/formFields';
import { AppFormContext } from 'contexts/AppFormContext';
import { commonTexts } from 'consts/text/index';
import { FetchInformationButton } from 'components/atoms/FetchInformationButton/FetchInformationButton';
import { nurseryRegistryInformationGetErrorParser } from 'utils/errorHandlers/nurseryRegistry/nurseryRegistryInformationGetErrorParser';
import { parseNurseryInformationDtoIntoInstitutionAddEditFormFields } from 'utils/parsers/nurseryRegistry/parseNurseryInformationDtoIntoInstitutionAddEditFormFields';

export const FetchNurseryRegistryInformationButton = () => {
    const { formError, setFormError } = useContext(AppFormContext);

    const { getFieldValue, validateFields, setFieldsValue } = useFormInstance();

    const getFormFieldValueToFetchBy = () => getFieldValue(formFields.nurseryRegistryNumber);

    const { data, error, isFetching, isFetchedAfterMount, refetch } = useAppQuery(
        'NURSERY_REGISTRY_INFORMATION',
        [],
        () =>
            StaffHTTPService.nurseryRegistry.getNurseryRegistryInformation(
                getFormFieldValueToFetchBy(),
            ),
        {
            enabled: false,
        },
    );

    useEffect(() => {
        if (error && !isFetching) {
            const nurseryRegistryInformationGetError = nurseryRegistryInformationGetErrorParser(
                error,
                commonTexts.errorMessages.nurseryRegistryDataFetching,
            );
            setFormError(nurseryRegistryInformationGetError);
        } else if (
            formError === commonTexts.errorMessages.nurseryRegistryDataFetching ||
            commonTexts.errorMessages.nurseryRegistryNotFound
        ) {
            setFormError('');
        }
        // it should change on error, isFetching only
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, isFetching]);

    useEffect(() => {
        if (data && isFetchedAfterMount) {
            setFieldsValue(parseNurseryInformationDtoIntoInstitutionAddEditFormFields(data));
        }
    }, [data, isFetchedAfterMount, setFieldsValue]);

    const fetchNurseryRegistryInfo = () =>
        validateFields([formFields.nurseryRegistryNumber])
            .then(() => {
                setFormError('');
                refetch();
            })
            // Intentional, I just don't want to do anything if there is an error
            .catch(() => {});

    return <FetchInformationButton isLoading={isFetching} onClick={fetchNurseryRegistryInfo} />;
};
